<template>
  <v-container>
    <v-alert
      :type="alertType"
      transition="scale-transition"
      v-model="alertShow"
      border="left"
      dismissible
    >{{alertMsg}}</v-alert>
    <v-alert type="warning" v-if="alert && !create">{{$t('DataHome.alert-nodevice')}}</v-alert>
    <template v-if="!create">
      <v-row v-if="!alert" justify="center" align="center">
        <v-col cols="12" sm="2">
          <div class="text-subtitle-2" v-text="$t('Admin.sort')"></div>
          <v-select :items="sortItems" v-model="sortFilter" solo></v-select>
        </v-col>
        <v-col cols="12" sm="2">
          <div class="text-subtitle-2" v-text="$t('Admin.type')"></div>
          <v-select
            clearable
            :items="['Name','Id','DeviceType','DeviceTypeId']"
            :placeholder="$t('Admin.enterType')"
            v-model="filterAttribute"
            solo
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="text-subtitle-2" v-text="$t('Admin.filter')"></div>
          <v-text-field :placeholder="$t('Admin.enterFilter')" solo v-model="filter"></v-text-field>
        </v-col>
      </v-row>
      <template v-if="loading">
        <v-row justify="center">
          <v-col>
            <div class="text-center mt-5">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <template v-if="!alert">
          <div class="text-center">
            <v-pagination v-model="page" :length="nbrPages" :total-visible="5"></v-pagination>
            <v-progress-circular class="ma-2 mt-3" v-if="!allLoaded" indeterminate color="primary"></v-progress-circular>
          </div>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="2">
              <v-text-field
                solo
                class="centered-input"
                v-model="countPageDevices"
                hide-details="true"
              ></v-text-field>
            </v-col>
            <v-btn v-if="!grid" fab small color="primary" @click="changeButton">
              <v-icon>mdi-apps</v-icon>
            </v-btn>
            <v-btn v-else fab small color="primary" @click="changeButton">
              <v-icon>mdi-view-list</v-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center" class="text-center">
            <v-col></v-col>
          </v-row>
        </template>

        <v-list v-if="!grid">
          <template v-for="(device, i) in devicesArray">
            <v-hover :key="device.id" v-slot:default="{ hover }">
              <v-flex>
                <v-card
                  :id="device.id"
                  style="cursor: pointer;"
                  :elevation="hover ? 10 : 2"
                  @click="sendChoosenDevice($event)"
                >
                  <v-container>
                    <p
                      class="text-wrap ml-4 mt-2"
                    >{{device.name}}</p>
                  
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle v-html="'ID : '+device.id"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'NetworkID : '+network.networkId"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'Network : '+network.name"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'DeviceTypeID : '+device.deviceTypeId"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'DeviceType : '+device.deviceType"></v-list-item-subtitle>
                    </v-list-item-content>
                    <delete-dialog @deletedevice="deleteDevice" :admin="admin" :id="device.id"></delete-dialog>
                  </v-list-item>
                  </v-container>
                  <v-divider></v-divider>
                  <v-card class="overflow-y-auto" max-height="250">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="mb-3">{{$t('DataHome.devices.lastdata')}}</v-list-item-title>
                        <vue-json-pretty :data="device.lastData"></vue-json-pretty>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card>
              </v-flex>
            </v-hover>
            <br :key="i" />
          </template>
        </v-list>
        <v-row justify="center" align="center" v-if="grid">
          <template v-for="(device, i) in devicesArray">
            <v-col :key="i" cols="12" md="6" lg="4">
              <v-hover :key="device.id" v-slot:default="{ hover }">
              <v-flex>
                <v-card
                  :id="device.id"
                  style="cursor: pointer;"
                  :elevation="hover ? 10 : 2"
                  @click="sendChoosenDevice($event)"
                >
                  <v-container>
                    <p
                      class="text-wrap ml-4 mt-2"
                    >{{device.name}}</p>
                  
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle v-html="'ID : '+device.id"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'NetworkID : '+network.networkId"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'Network : '+network.name"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'DeviceTypeID : '+device.deviceTypeId"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="'DeviceType : '+device.deviceType"></v-list-item-subtitle>
                    </v-list-item-content>
                    <delete-dialog @deletedevice="deleteDevice" :admin="admin" :id="device.id"></delete-dialog>
                  </v-list-item>
                  </v-container>
                  <v-divider></v-divider>
                  <v-card class="overflow-y-auto" max-height="250">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="mb-3">{{$t('DataHome.devices.lastdata')}}</v-list-item-title>
                        <vue-json-pretty :data="device.lastData"></vue-json-pretty>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card>
              </v-flex>
            </v-hover>
            </v-col>
          </template>
        </v-row>
      </template>

      <v-row>
        <v-col class="text-center">
          <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
            <v-icon left>mdi-arrow-left</v-icon>
            {{$t('DataHome.back')}}
          </v-btn>
          <v-btn class="ma-2" tile outlined color="primary" @click="$emit('create')">
            <v-icon left>mdi-plus-circle</v-icon>
            {{$t('DataHome.create')}}
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <createDevice
      @back="$emit('stopcreate')"
      :networkId="networkId"
      @save="newDeviceSaved"
      v-if="create"
    ></createDevice>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

import VueJsonPretty from "vue-json-pretty";

import DeleteDialogComponent from "./DeleteDialog";
import CreateDeviceComponent from "./CreateDevice";

export default {
  components: {
    "delete-dialog": DeleteDialogComponent,
    VueJsonPretty,
    createDevice: CreateDeviceComponent,
  },
  props: {
    networkId: String,
    network: Object,
    create: Boolean,
  },

  data: () => ({
    devices: [],
    alert: false,
    interval: null,
    alertShow: false,
    alertMsg: null,
    alertType: "error",
    loading: true,
    filterAttribute: undefined,
    filter: "",
    sortFilter: "",
    sortItems: [],
    length: 0,
    allLoaded: false,
    page: 1,
    nbrPages: 1,
    grid: false,
  }),
  computed: {
    filteredArray: function () {
      let array = this.devices;
      if (this.filterAttribute != undefined) {
        array = [];
        this.devices.forEach((device) => {
          if (
            device[
              this.filterAttribute.charAt(0).toLowerCase() +
                this.filterAttribute.slice(1)
            ]
              .toLowerCase()
              .startsWith(this.filter.toLowerCase())
          ) {
            array.push(device);
          }
        });
      }
      return array;
    },
    devicesArray: function () {
      let array = this.filteredArray;
      function compareWithParam(param) {
        return function compare(d1, d2) {
          let a = d1.name;
          let b = d2.name;
          if (param == "Id") {
            a = d1.id;
            b = d2.id;
          } else if (param == "DeviceType") {
            a = d1.deviceType;
            b = d2.deviceType;
          } else if (param == "DeviceTypeId") {
            a = d1.deviceTypeId;
            b = d2.deviceTypeId;
          }
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        };
      }
      if (array != undefined) {
        array.forEach((device) => {
          try {
            device.lastData.data = JSON.parse(device.lastData.data);
          } catch (e) {
            //
          }
        });
        switch (this.sortFilter) {
          default:
            return array
              .sort(compareWithParam(this.filterAttribute))
              .slice((this.page - 1) * 50, this.page * 50);

          case this.$t("Admin.ascending"):
            return array
              .sort(compareWithParam(this.filterAttribute))
              .slice((this.page - 1) * 50, this.page * 50);

          case this.$t("Admin.descending"):
            return array
              .sort(compareWithParam(this.filterAttribute))
              .reverse()
              .slice((this.page - 1) * 50, this.page * 50);
        }
      } else {
        return array.slice((this.page - 1) * 50, this.page * 50);
      }
    },
    admin: function () {
      let index = this.network.scopes.findIndex((scope) => {
        return scope == "admin" || scope == "creator";
      });
      return index >= 0;
    },
  },
  watch: {
    filteredArray(value) {
      if (value.length == 0) {
        this.nbrPages = 1;
        this.countPageDevices = "0/" + value.length;
      } else {
        this.nbrPages = Math.ceil(value.length / 50);

          this.countPageDevices = (this.page - 1) * 50 + 1 + "/" + value.length;
 
      }
    },
    devicesArray(value) {
      if (value.length > 0) {
        this.loading = false;
      }
    },
    alert() {
      this.loading = false;
    },
    create: function (value) {
      if (!value) {
            axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/network/" +
          this.networkId +
          "/devices",
        {
          headers: { Authorization: tokenStore.getToken() },
        }
      )
      .then((res) => {
        if (res.data.devices.length == 0) {
          this.alert = true;
        } else {
          this.length = res.data.devices.length;
          let tmp = [];
          this.nbrPages = Math.ceil(this.length / 50);
          res.data.devices.forEach((device) => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/deviceType/" +
                  device.deviceTypeId,
                {
                  headers: { Authorization: tokenStore.getToken() },
                }
              )
              .then((res) => {
                device.deviceType = res.data.deviceType.name;
                device.network = this.network.name;
                this.alert = false;
                tmp.push(device);
                if (tmp.length % 50 == 0) {
                  this.devices = JSON.parse(JSON.stringify(tmp));
                } else if (this.length == tmp.length) {
                  this.devices = JSON.parse(JSON.stringify(tmp));
                  this.allLoaded = true;
                }
              })
              .catch(() => {
                this.alertMsg = this.$t("DataHome.api-error");
                this.alertType = "error";
                this.alertShow = true;
              });
          });
        }
      })
      .catch(() => {
        this.alertMsg = this.$t("DataHome.api-error");
        this.alertType = "error";
        this.alertShow = true;
      });
      }
    },
  },
  methods: {
    changeButton() {
      this.grid = !this.grid;
    },
    newDeviceSaved: function () {
      this.$emit("stopcreate");
      this.alertMsg = this.$t("DataHome.insert-success");
      this.alertType = "success";
      this.alertShow = true;
      this.alert = false;
    },
    sendChoosenDevice: function (event) {
      let index = this.devices.findIndex((e) => {
        return e.id == event.currentTarget.id;
      });
      this.$emit("choosendevice", this.devices[index]);
    },

    deleteDevice: function (id) {
      axios
        .delete(process.env.VUE_APP_API_ADDR + "/api/device/" + id, {
          headers: { Authorization: tokenStore.getToken() },
        })
        .then((res) => {
          if (res.data.success) {
            this.alertMsg = this.$t("DataHome.delete-success");
            this.alertType = "success";
            this.alertShow = true;
            this.devices = [];
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/network/" +
                  this.networkId +
                  "/devices",
                {
                  headers: { Authorization: tokenStore.getToken() },
                }
              )
              .then((res) => {
                if (res.data.devices.length == 0) {
                  this.alert = true;
                } else {
                  this.length = res.data.devices.length;
                  res.data.devices.forEach((device) => {
                    axios
                      .get(
                        process.env.VUE_APP_API_ADDR +
                          "/api/deviceType/" +
                          device.deviceTypeId,
                        {
                          headers: { Authorization: tokenStore.getToken() },
                        }
                      )
                      .then((res) => {
                        device.deviceType = res.data.deviceType.name;
                        device.network = this.network.name;
                        this.alert = false;
                        this.devices.push(device);
                      })
                      .catch(() => {
                        this.alertMsg = this.$t("DataHome.api-error");
                        this.alertType = "error";
                        this.alertShow = true;
                      });
                  });
                }
              })
              .catch(() => {
                this.alertMsg = this.$t("DataHome.api-error");
                this.alertType = "error";
                this.alertShow = true;
              });
          }
        })
        .catch(() => {
          this.alertMsg = this.$t("DataHome.api-error");
          this.alertType = "error";
          this.alertShow = true;
        });
    },
  },
  beforeMount: function () {
    this.sortItems = [this.$t("Admin.ascending"), this.$t("Admin.descending")];
    this.sortFilter = this.sortItems[0];
    axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/network/" +
          this.networkId +
          "/devices",
        {
          headers: { Authorization: tokenStore.getToken() },
        }
      )
      .then((res) => {
        if (res.data.devices.length == 0) {
          this.alert = true;
        } else {
          this.length = res.data.devices.length;
          let tmp = [];
          this.nbrPages = Math.ceil(this.length / 50);
          res.data.devices.forEach((device) => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/deviceType/" +
                  device.deviceTypeId,
                {
                  headers: { Authorization: tokenStore.getToken() },
                }
              )
              .then((res) => {
                device.deviceType = res.data.deviceType.name;
                device.network = this.network.name;
                this.alert = false;
                tmp.push(device);
                if (tmp.length % 50 == 0) {
                  this.devices = JSON.parse(JSON.stringify(tmp));
                } else if (this.length == tmp.length) {
                  this.devices = JSON.parse(JSON.stringify(tmp));
                  this.allLoaded = true;
                }
              })
              .catch(() => {
                this.alertMsg = this.$t("DataHome.api-error");
                this.alertType = "error";
                this.alertShow = true;
              });
          });
        }
      })
      .catch(() => {
        this.alertMsg = this.$t("DataHome.api-error");
        this.alertType = "error";
        this.alertShow = true;
      });
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.interval = setInterval(() => {
      axios
        .get(
          process.env.VUE_APP_API_ADDR +
            "/api/network/" +
            this.networkId +
            "/devices",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          if (res.data.devices.length == 0) {
            this.alert = true;
          } else {
            this.length = res.data.devices.length;
            res.data.devices.forEach((device) => {
              let index = this.devices.findIndex((e) => {
                return e.id == device.id;
              });
              if (index == -1) {
                axios
                  .get(
                    process.env.VUE_APP_API_ADDR +
                      "/api/deviceType/" +
                      device.deviceTypeId,
                    {
                      headers: { Authorization: tokenStore.getToken() },
                    }
                  )
                  .then((res) => {
                    device.deviceType = res.data.deviceType.name;
                    device.network = this.network.name;
                    this.alert = false;
                    this.devices.push(device);
                  })
                  .catch(() => {
                    this.alertMsg = this.$t("DataHome.api-error");
                    this.alertType = "error";
                    this.alertShow = true;
                  });
              } else {
                device.deviceType = this.devices[index].deviceType;
                this.devices.splice(index, 1, device);
              }
            });
          }
        })
        .catch(() => {
          this.alertMsg = this.$t("DataHome.api-error");
          this.alertType = "error";
          this.alertShow = true;
        });
    }, 60000);
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>

